<template>
  <div class="w-full my-3 border-brand-background-light-blue" :class="[ bold ? 'border' : 'border-t']"></div>
</template>
<script>
export default {
  props: {
    bold: {
      type: Boolean,
      default: false
    }
  }
}
</script>